import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import type { ENUM_OPTIONS_REASON_TO_BLOCK_TYPE } from './constants';
import { GET_BALANCE_DELIVERYMAN } from './constants';
import { apiClient } from '@/_config/lib/axios/api-client';

const getBlockReasons = () => {
  return apiClient
    .get<ENUM_OPTIONS_REASON_TO_BLOCK_TYPE[]>(`/entregadores/block-reasons`)
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetBlockReasonsResponse = Awaited<ReturnType<typeof getBlockReasons>>;

export const useGetBlockReasons = (
  options: Omit<
    UseQueryOptions<
      GetBlockReasonsResponse,
      unknown,
      GetBlockReasonsResponse,
      string[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_BALANCE_DELIVERYMAN],
    queryFn: () => getBlockReasons(),
    ...options,
  });
};
